module.exports = __webpack_public_path__ + "img/shopping.0c9daf0a.svg";